require('./dist/ui-bootstrap-tpls');

module.exports = 'ui.bootstrap';



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-bootstrap/index.js
// module id = 21
// module chunks = 36